import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import Counter from 'components/commons/Counter';
// import connect from 'react-redux';

const Container = GlobalStyle.BasicBlock.extend`
  padding: 30px;
`

const Header = styled.div`
  font-size: 22px;
  color: #4a4a4a;
  border-bottom: solid 1px #D9D9D9;
  padding-bottom: 30px;
  font-weight: bold;
`

const Main = styled.div`
  padding: 30px 0 15px 0;
  border-bottom: solid 1px #D9D9D9;
`

const Flex = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  flex-direction: ${props => props.direction? props.direction:'row'};
  align-items: ${props => props.direction? 'start':''};
  padding: ${props => props.direction? '10px 0 0 10px':''};
`

const Tag = styled.div`
  font-size: 14px;
  color: #4a4a4a;
  font-weight: ${props => props.weight? props.weight:500};
  min-width: 125px;
  text-align: ${({ left }) => left ? 'left' : 'right'};
  margin-right: 10px;
`
const Money = styled.div`
  color: ${Colors.MAIN_COLOR};
  font-size: 20px;
`

const Textarea = styled.textarea`
  width: 416px;
  height: ${props => props.height}px;
  background-color: #FAFAFA;
  color: #222328;
  word-break: break-word;
  border: ${({ error }) => error ? `solid 1px ${Colors.Red}` : 'solid 1px #DDDDDD'};
  border-radius: 2px;
  padding: 10px;
  font-size: 14px;
`

const Footer = styled.div`
  padding: 30px 0 0 0;
`

const Button = styled.button`
  background-color: ${Colors.MAIN_COLOR};
  font-size: 16px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  padding: 12px 32px;
  color: #fff;
  opacity: ${({ disable }) => disable ? .5 : 1}; 
  cursor: ${({ disable }) => disable ? 'auto' : 'pointer'};
  margin: 0 20px 0 15px;
  font-family: PingFangTC-Semibold;
  letter-spacing: 0;
`

const Span = styled.span`
  color: ${props => props.color? props.color:Colors.MAIN_COLOR};
`

const Input = styled.input`
  width: 416px;
  height: 44px;
  background-color: #FAFAFA;
  color: #222328;
  word-break: break-word;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ error }) => error ? Colors.Red : '#DDD'};
  border-radius: 2px;
  padding: 10px;
  font-size: 14px;
`

const Select = styled.select`
  width: 416px;
  height: 44px;
  background-color: #FAFAFA;
  color: #222328;
  word-break: break-word;
  border: solid 1px #DDDDDD;
  border-radius: 2px;
  padding: 10px;
  font-size: 14px;
`

const RadioButton = styled.div`
  width: 200px;
  height: 44px;
  color: ${props => props.isChecked? Colors.MAIN_COLOR:'#6A6A6A'};
  font-weight: 400;
  border: solid 1px #CCCCCC;
  border-color: ${props => props.isChecked? Colors.MAIN_COLOR:'#CCC'};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  margin-left: ${props => props.marginLeft? props.marginLeft:4}px;
  margin-right: ${props => props.marginRight? props.marginRight:0}px;
  > i {
    display: ${props => props.isChecked? 'block':'none'};
    position: absolute;
    right: 0;
    top: -4px;
    font-size: 18px;
    color: ${Colors.MAIN_COLOR};
  }
`

const ConfirmButton = styled.div`
  width: 415px;
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FAFAFA;
  border: ${({ error }) => error ? `1px solid ${Colors.Red}` : '1px solid #D6D6D6'};
  border-radius: 3px;
  padding: 16px 10px 16px 12px;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.10);
  > i {
    font-size: 40px;
    border: 1px;
    margin-right: 12px;
    color: #C1C1C1;
    cursor: pointer;
  }

  > p {
    color: #000;
    font-size: 14px;
    margin: 0;
  }
`

class TradeDetail extends PureComponent {
  state = {
    isConfirm: false,
    evaluation: "positive",
    tradeMoney: 200,
  }

  renderBankDetail = () => {

    const { data } = this.props;

    const {
      bankcode,
      currentBank,
      currentSubBankCode,
      isBankcodeError,
      isBankaccountError,
      currentBankCode,
      bankData,
      bankaccount,
    } = data;

    return (
      <Main>
        <Flex>
          <Tag>轉入銀行代碼：</Tag>
          <Input
            maxLength="7"
            placeholder="請輸入銀行代碼7碼"
            error={isBankcodeError}
            onChange={this.props.updateTxtContentBankcode}
            value={bankcode}
          />
          <Flex direction={'column'}>
            <Span color={'#4A4A4A'}>請輸入銀行代碼7碼 由系統自動為您帶出銀行/分行名稱;</Span>
            <Span color={'#4A4A4A'}>或選擇銀行/分行名稱 由系統自動帶出銀行代碼</Span>
          </Flex>
        </Flex>
        <Flex>
          <Tag>轉入銀行總稱：</Tag>
          <Select value={currentBankCode} onChange={this.props.onBankChange}>
            <option value="" disabled selected>銀行別</option>
            {
              bankData.map(({ bankcode, bank }, index) => {
                return (
                  <option key={index} value={bankcode}>{bankcode} {bank}</option>
                )
              })
            }
          </Select>
        </Flex>
        {
          currentBank && currentBank.subbank && (
            <Flex>
              <Tag>轉入分行總稱：</Tag>
              <Select value={currentSubBankCode} onChange={this.props.onSubBankChange}>
                <option value="" disabled selected>分行別</option>
                {currentBank.subbank.map(({ subcode, subname }) => {
                  return (
                    <option key={subcode} value={subcode}>{subcode} {subname}</option>
                  )
                })}
              </Select>
            </Flex>
          )
        }
        <Flex>
          <Tag>轉入銀行帳號：</Tag>
          <Input
            type="text"
            maxLength="14"
            placeholder="最多14碼"
            error={isBankaccountError}
            onChange={this.props.updateTxtContentBankaccount}
            value={bankaccount}
          />
        </Flex>
      </Main>
    )
  }

  renderConfirmBlock = () => {

    const { data } = this.props;

    const {
      agree,
      defaultgrade,
      isAgreeError,
    } = data;

    return (
      <Main>
        <Flex>
          <Tag>&emsp;&emsp;評價：</Tag>
          <RadioButton
            isChecked={defaultgrade === 0}
            onClick={this.props.chooseEvaluationToNeutral} >
            中立評價
            <i className="zmdi zmdi-check-square"></i>
          </RadioButton>
          <RadioButton marginLeft={15} marginRight={16}
            isChecked={defaultgrade === 1}
            onClick={this.props.chooseEvaluationToNegative}>
            負面評價
            <i className="zmdi zmdi-check-square"></i>
          </RadioButton>
          <Span color={'#4A4A4A'}>(若買方48小時內未付款取消交易時，自動給予評價)</Span>
        </Flex>
        <Flex>
          <Tag>注意事項：</Tag>
          <ConfirmButton error={isAgreeError}>
            <i className={agree ? "zmdi zmdi-check-square" : "zmdi zmdi-square-o"}
              onClick={this.props.toggleAgree} />
            <p>我同意：9199僅提供雙方聯繫服務，下單後買家將與您聯繫交易，雙方交易商品、金額流程均與9199無任何關聯，請雙方確實進行誠信交易！</p>
          </ConfirmButton>
        </Flex>
      </Main>
    )
  }
  render() {

    const {
      data,
      isPurchase,
      mode,
    } = this.props; 

    const {
      name,
      money,
      num,
      vPrice,
      dollar,
      commissionPrice,
      minDollar,
      maxDollar,
      proportion,
      error,
      character,
      descriptoin,
      tradetime,
      isServerroleError,
      isOrdertimeError,
      isOrderprocessError,
    } = data;

    return (
      <Container>
        <Header>品牌旗艦會員：{name}</Header>
        <Main>
          <Flex>
            <Tag>比例(台幣：虛幣)：</Tag>
            <Money>{money}</Money>
          </Flex>
          {
            num && (
              <Flex>
                <Tag>庫存：</Tag>
                <Tag left>{num}</Tag>
              </Flex>
            )
          }
          <Flex>
            <Tag>伺服器內角色：</Tag>
            <Textarea
              height={44}
              type="text"
              placeholder="玩家伺服器內角色"
              onChange={this.props.handleCharacterInput}
              value={character}
              error={isServerroleError}
            />
          </Flex>
          <Flex>
            <Tag>交易時間：</Tag>
            <Textarea
              height={44}
              type="text"
              onChange={this.props.handleTradetimeInput}
              placeholder='請輸入交易時間'
              value={tradetime}
              error={isOrdertimeError}
            />
          </Flex>
          <Flex>
            <Tag>交易過程詳述：</Tag>
            <Textarea
              height={65}
              type="text"
              placeholder="請注意！伺服器內角色所填寫資料，如與實際交易角色ID不同，供應商將取消改筆訂單"
              onChange={this.props.handleDescriptoinInput}
              value={descriptoin}
              error={isOrderprocessError}
            />
          </Flex>
        </Main>
        {isPurchase && this.renderBankDetail()}
        {isPurchase && this.renderConfirmBlock()}
        <Footer>
          <Flex>
            <Tag>
              {mode === "purchase" ? '出售金額 (台幣)' : '購買金額 (台幣)：'}
            </Tag>
            <Counter
              number={dollar}
              add={this.props.addTradeMoney}
              minus={this.props.minusTradeMoney}
              handleChange={this.props.handleDollarChange}
              min={minDollar}
              max={maxDollar} 
              error={error}
            />
            {
              this.props.disableSubmit ?
              <Button disable>
                {mode === "purchase" ? '立刻出售' : '立刻購買'}
              </Button>
              :
              <Button
                onClick={this.props.submit}
              >
                {mode === "purchase" ? '立刻出售' : '立刻購買'}
              </Button>
            }
            {
              mode === "purchase" ?
              <Tag weight={400}>換算虛幣<Span>{` ${vPrice} `}</Span></Tag>
              :
              <Tag weight={400}>換算虛幣<Span>{` ${vPrice} `}</Span>{`= ${dollar || 0} 元(購買金額) - ${commissionPrice} 元(內含手續費) x ${proportion} (幣值)`}</Tag>
            }
          </Flex>
        </Footer>
      </Container>
    )
  }
}

/*--------------------------
	export
--------------------------*/
export default TradeDetail;
